var React = require('react');

function PlayIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36 20.268C37.3333 21.0378 37.3333 22.9623 36 23.7321L3 42.7846C1.66667 43.5544 1.77809e-06 42.5922 1.84539e-06 41.0526L3.51101e-06 2.94744C3.57831e-06 1.40784 1.66667 0.445588 3 1.21539L36 20.268Z","fill":"white","fillOpacity":"0.7"}));
}

PlayIconInline.defaultProps = {"width":"37","height":"44","viewBox":"0 0 37 44","fill":"none"};

module.exports = PlayIconInline;

PlayIconInline.default = PlayIconInline;
